import { ChangeDetectionStrategy, Component } from '@angular/core'
import { BaseLoaderContainer } from '@adex/shared/models/loaders/base-loader-container'
import { IDynamicFormModel } from '@adex/shared/modules/dynamic-form/models/dynamic-form.model'
import { ModelLoaderService } from '@adex/shared/services/model-loader.service'
import { Store } from '@ngrx/store'
import { ISetPasswordFormData } from '../../models/set-password-form-data'
import { resetPasswordSetPassword } from '@adex/store/actions/auth.actions'
import { ActivatedRoute } from '@angular/router'
import { take } from 'rxjs/operators'
import { navigate } from '@adex/store/actions/global.actions'
import { appRoutes } from '@adex/shared/routing/routes'
import { DynamicFormStateService } from '@adex/shared/modules/dynamic-form'


@Component({
  selector: 'adex-reset-set-password-container',
  templateUrl: './reset-set-password-container.component.html',
  styleUrls: [ './reset-set-password-container.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ DynamicFormStateService ]
})
export class ResetSetPasswordContainerComponent extends BaseLoaderContainer<IDynamicFormModel> {
  private token: string

  constructor(private readonly store: Store, private readonly routing: ActivatedRoute, modelLoader: ModelLoaderService) {
    super(modelLoader, 'set_password-form')
    this.routing.queryParamMap.pipe(take(1)).subscribe(params => {
      const token = params.get('token')
      if (!token) return this.store.dispatch(navigate({ commands: appRoutes.root }))
      this.token = token
    })
  }

  public onSubmitForm(data: ISetPasswordFormData): void {
    const { password } = data
    const { token } = this
    this.store.dispatch(resetPasswordSetPassword({ resetPasswordDto: { password, token } }))
  }

}
